import React from "react";
import DynamicSelect from "../../../shared/DynamicSelect";
import { useState } from "react";
import NumberInput from "../../../shared/NumberInput";
import { DeleteTwoTone} from "@material-ui/icons";
import { useEffect } from "react";
import DynamicSelectWithSearch from "../../../shared/DynamicSelectWithSearch";
import { formatValidInput, formatValidSelect } from "../../../../helpers/FormatHelper";

export function IncomingRow({ customerID, rowObject, rowID, currenciesList, onDeleteRow, onUpdateFieldRow, validations,
  autoFocus, openAlert, instruments, deliveryMethods}) {

    const [amount, setAmount] = useState(0);
    const [currencyID, setCurrencyID] = useState('');
    const [sellScale, setSellScale] = useState(2);  
    const [instrument, setInstrument] = useState('');
    const [deliveryMethod, setDeliveryMethod] = useState('');
    const [deliveryMethodsFilter, setDeliveryMethodsFilter] = useState([]);

    useEffect(() => {
    if (rowObject.CurrencyID) {     
        const selectCcy = currenciesList.find(c=> c.value===rowObject.CurrencyID);
        if(selectCcy)
        {
            dropdownCurrenciesChangeHandler(selectCcy);
        }

        setAmount(rowObject.Amount);
        
        setSellScale(rowObject.CurrencyScale);
        //setInstrument(rowObject.Instrument);
        if(instrument !== rowObject.Instrument)
        {
          dropdownInstrumentChangeHandler({value: rowObject.Instrument});
        }
        if(deliveryMethod !== rowObject.DeliveryMethod)
        {
          setDeliveryMethod(rowObject.DeliveryMethod);
        }
    }
  }, [rowObject, currenciesList]);


    const dropdownCurrenciesChangeHandler = async(item) =>
    {
       if(item.value && item.value !== '')
      { 
        if(rowObject.CurrencyID !== '' && rowObject.CurrencyID === item.value )
            {    
                setCurrencyID(rowObject.CurrencyID);
            }
            else{
                setCurrencyID(item.value);
                setAmount(0);
                setSellScale(item.NumberOfDecimals);

                onUpdateFieldRow(rowID, 'CurrencyID', item.value);
                onUpdateFieldRow(rowID, 'CurrencyName', item.name);
                onUpdateFieldRow(rowID, 'CurrencyScale', item.NumberOfDecimals);
                onUpdateFieldRow(rowID, 'Amount', 0);
            }
        }
    }

    const onBlurAmount = async() =>{
      onUpdateFieldRow(rowID, 'Amount', amount);
    }
    
    const onDeleteOrderRow = () => {
      onDeleteRow(rowID);
    };
  
  const dropdownInstrumentChangeHandler = (item) =>
  {
    if(item.value && item.value !== '')
    {
      let methodsFilter = deliveryMethods[item.value];
      if(methodsFilter === undefined || item.value === "Client's Vostro Account"){
        methodsFilter = [];
      }

      setInstrument(item.value);
      setDeliveryMethodsFilter(methodsFilter);
      onUpdateFieldRow(rowID,'Instrument',item.value);
    }
  }

    const dropdownDeliveryMethodChangeHandler = (item) =>
  {
       if(item.value && item.value !== '')
      {
        setDeliveryMethod(item.value);
        onUpdateFieldRow(rowID, 'DeliveryMethod', item.value);
      }
  }

  const onChangeAmount =  (event) => 
    {
      setAmount(event.target.value);
    }


    return <>
    <tr key={rowID}>
        <td>
            <DynamicSelectWithSearch id={`dd-currencies-${rowID}`}
              key={`dd-currencies-${rowID}`}
              className={formatValidSelect(validations.CurrencyID)}
              data={currenciesList}
              placeholder='Select currency...'
              getValue={dropdownCurrenciesChangeHandler}
              objValue={{ value: currencyID }}
              autoFocus={autoFocus}/>     
        </td>
        
        <td>
            <NumberInput id={`txt-amount-${rowID}`} key={`txt-amount-${rowID}`} className={formatValidInput(validations.Amount)} value={amount} 
            onBlur={onBlurAmount} onChange ={onChangeAmount} scale={sellScale} type="Currency" />
        </td>
        <td>  
              <DynamicSelect key={`dd-instrument-${rowID}`}
                id={`dd-instrument-${rowID}`}
                className={formatValidSelect(validations.Instrument)}
                data={instruments}
                placeholder='Select a instrument...'
                getValue={dropdownInstrumentChangeHandler}
                objValue={{value:instrument}}/> 
        </td>
        <td>  
              <DynamicSelect key={`dd-condition-${rowID}`}
                id={`dd-condition-${rowID}`}
                className={formatValidSelect(validations.DeliveryMethod)}
                data={deliveryMethodsFilter}
                placeholder='Select a delivery method...'
                getValue={dropdownDeliveryMethodChangeHandler}
                objValue={{value:deliveryMethod}}/> 
        </td>
        <td>
            <DeleteTwoTone id={`delete-row-${rowID}`} key ={`delete-row-${rowID}`} style={{ marginRight: '20px', marginTop: '10px', cursor:'pointer'  }} onClick={onDeleteOrderRow} twoToneColor="#34c521"  />
        </td>
    </tr>
    </>

}

export default IncomingRow